// CON-9073 — Meta's and Baidu's page renderers run our client-side GraphQL and
// report 429/503 responses as Apollo "Network error" events. None of those
// responses come from our servers (CloudFront and the ALB log none on
// /graphql), and a crawler cannot act on them, so they only add noise.
//
// The same responses also reach Sentry unwrapped, as the ApolloError caught by
// an error boundary such as CMSComponentErrorBoundary. errorLink in
// makeApolloClient.js wraps the Apollo error in a new Error, so the status of
// the first kind is only available as the `httpStatus` tag it sets; the second
// kind is read from the networkError on the original exception. `is_bot` comes
// from the initial scope in instrumentation-client.js.
const BOT_NETWORK_ERROR_STATUSES = ['429', '503'];

// Most of these events are dropped, but a sample is kept so the volume stays
// visible in Sentry (multiply the count by 1 / rate; the sample rate is tagged
// on each kept event).
export const BOT_NETWORK_ERROR_SAMPLE_RATE = 0.01;

const getNetworkErrorStatus = (event, hint) =>
  event?.tags?.httpStatus ?? hint?.originalException?.networkError?.statusCode;

export const isBotNetworkOverloadError = (event, hint) =>
  event?.tags?.is_bot === 'true' &&
  BOT_NETWORK_ERROR_STATUSES.includes(
    String(getNetworkErrorStatus(event, hint))
  );

/**
 * Returns null for most crawler 429/503 network errors, and the event with a
 * sample-rate tag for the sampled few. Every other event passes through
 * unchanged, so real-user errors and other crawler errors (such as render
 * failures) are still reported in full.
 */
export const sampleBotNetworkError = (event, hint, random = Math.random) => {
  if (!isBotNetworkOverloadError(event, hint)) {
    return event;
  }
  if (random() >= BOT_NETWORK_ERROR_SAMPLE_RATE) {
    return null;
  }
  return {
    ...event,
    tags: {
      ...event.tags,
      botNetworkErrorSampleRate: String(BOT_NETWORK_ERROR_SAMPLE_RATE),
    },
  };
};
